<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('centrosDeCusto') }} </h3>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="10"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>

                <kendo-label class="k-checkbox-label"
                    text="{{ customMsgService.translate('mostrarCentrosDeCustoDescontinuados') }}"></kendo-label>
                <input type="checkbox" [(ngModel)]="getCentrosDeCustoDescontinuados" (change)="checkValue()"
                    kendoCheckBox />

                <button [hidden]="!canEdit()" kendoButton icon="add" [title]="customMsgService.translate('btnCriar')"
                    (click)="open()" themeColor="primary">
                </button>

                <button kendoButton type="button" [hidden]="!canCreate()"
                    [title]="customMsgService.translate('btnImportar')" (click)="upload()" icon="upload"
                    themeColor="warning">
                </button>

                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning">
                </button>

            </ng-template>

            <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="500">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nome }} </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="codigo" [title]="customMsgService.translate('codigo')" [width]="250">
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        (click)="openEdit(dataItem)" [primary]="true"></button>

                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        (click)="delete(dataItem)" themeColor="error"></button>

                </ng-template>
            </kendo-grid-column>

            <kendo-grid-pdf fileName="{{customMsgService.translate('centrosDeCusto')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('centrosDeCusto') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="220">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="customer-name"> {{ dataItem.nome }} </div>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="codigo" [title]="customMsgService.translate('codigo')" [width]="120">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData"
                fileName="{{customMsgService.translate('centrosDeCusto')}}.xlsx"></kendo-grid-excel>
        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>